export const DEFAULT_PRINTFUL_PRODUCTS_PRICE_PROFIT_PERCENTAGE = 200;
export const DEFAULT_PRINTFUL_PRODUCTS_PRICE_DISCOUNT_PERCENTAGE = 20;

export const PRINTFUL_PRODUCTS_PRICE_IDS = {
    ALL_PRINTFUL_PRODUCTS_PRICE: 'all-printful-products-price',
}

export const PRINTFUL_PRODUCTS_PRICE_FIELDS_LIST: any = [
    /*{attribute: "id", label: "Id", cssClass: ''},
    {attribute: "category_id", label: "Category Id", cssClass: ''},
    {attribute: "product_id", label: "Product Id", cssClass: ''},*/
    /*{attribute: "product_type", label: "Product Type", cssClass: ''},
    {attribute: "category", label: "Category", cssClass: ''},*/
    {
        attribute: "title",
        label: "Title",
        cssClass: 'w-96 font-semibold',
        isTitle: true,
        otherAttributes: ['product_type', 'category']
    },
    {attribute: "costRange", label: "Cost Range (USD)", cssClass: 'text-center text-purple-700 font-bold', prefix: '$'},
    {
        attribute: "profitPercentage",
        label: "Profit Percentage (USD)",
        cssClass: 'text-center text-green-700 font-bold',
        suffix: '%'
    },
    {
        attribute: "discountPercentage",
        label: "Discount Percentage (USD)",
        cssClass: 'text-center text-red-700 font-bold',
        suffix: '%'
    },
    {attribute: "msrpRange", label: "MSRP Range (USD)", cssClass: 'text-center', prefix: '$'},
    {attribute: "msrpProfitRange", label: "MSRP Profit Range (USD)", cssClass: 'text-center', prefix: '$'},
    {
        attribute: "salePriceRange",
        label: "Sale Price Range (USD)",
        cssClass: 'text-center text-blue-700 font-bold',
        prefix: '$'
    },
    {
        attribute: "discountAmountRange",
        label: "Discount Amount Range (USD)",
        cssClass: 'text-center text-gray-700 font-bold',
        prefix: '$'
    },
    {
        attribute: "saleProfitRange",
        label: "Sale Profit Range (USD)",
        cssClass: 'text-center text-green-700 font-bold',
        prefix: '$'
    },
    // {attribute: "updatedOn", label: "Updated On", cssClass: '', isDate: true},
    /*{attribute: "variant_id", label: "Variant Id", cssClass: ''},
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "price", label: "Price", cssClass: ''},
    {attribute: "size", label: "Size", cssClass: ''},
    {attribute: "color", label: "Color", cssClass: ''},
    {attribute: "colorCode", label: "Color Code", cssClass: ''},*/
];

export const PRINTFUL_PRODUCTS_PRICE_INPUT_FIELD_GROUPS: any = [
    {attribute: "price", label: "Price", editable: true},
    {attribute: "title", label: "Title", editable: false},
    {attribute: "detail", label: "Detail", editable: false},
    {attribute: "cost", label: "Cost", editable: false},
    {attribute: "msrp", label: "MSRP", editable: false},
    {attribute: "sale", label: "Sale", editable: false},
    {attribute: "discount", label: "Discount", editable: false},
]

export const PRINTFUL_PRODUCTS_PRICE_INPUT_FIELDS: any = [
    {
        attribute: "profitPercentage",
        label: "Profit Percentage",
        type: 'number',
        group: 'price',
        cssClass: 'w-1/2 text-blue-700 font-bold'
    },
    {
        attribute: "discountPercentage",
        label: "Discount Percentage",
        type: 'number',
        group: 'price',
        cssClass: 'w-1/2 text-red-700 font-bold'
    },
    {attribute: "title", label: "Product Title", type: 'text', group: 'title', cssClass: 'w-2/3'},
    {attribute: "product_id", label: "Product Id", type: 'text', group: 'title', cssClass: 'w-1/3'},
    {attribute: "product_type", label: "Product Type", type: 'text', group: 'detail', cssClass: 'w-1/2'},
    {attribute: "category", label: "Category", type: 'text', group: 'detail', cssClass: 'w-1/2'},
    {
        attribute: "costRange",
        label: "Cost Range (USD)",
        type: 'text',
        group: 'cost',
        cssClass: 'w-1/2 text-purple-700 font-bold'
    },
    {attribute: "msrpRange", label: "MSRP Range (USD)", type: 'text', group: 'msrp', cssClass: 'w-1/2'},
    {attribute: "msrpProfitRange", label: "MSRP Profit Range (USD)", type: 'text', group: 'msrp', cssClass: 'w-1/2'},
    {
        attribute: "salePriceRange",
        label: "Sale Price Range (USD)",
        type: 'text',
        group: 'sale',
        cssClass: 'w-1/2 text-blue-700 font-bold'
    },
    {
        attribute: "saleProfitRange",
        label: "Sale Profit Range (USD)",
        type: 'text',
        group: 'sale',
        cssClass: 'w-1/2 text-sky-700 font-bold'
    },
    {
        attribute: "discountAmountRange",
        label: "Discount Amount Range (USD)",
        type: 'text',
        group: 'discount',
        cssClass: 'w-1/2 text-gray-700 font-bold'
    },
];

export const SYNC_OPTIONS_LIST = [
    // {key: 'all', label: 'All'},
    {key: 'added', label: 'Added To Sync'},
];

export const PRINTFUL_PRODUCTS_PRICE_FILTER_FIELDS: any = [
    {attribute: "product_type", label: "Product Type", type: 'select', group: 'filter', cssClass: '', options: []},
    {attribute: "category", label: "Category", type: 'select', group: 'filter', cssClass: '', options: []},
    {attribute: "sync", label: "Sync", type: 'select', group: 'filter', cssClass: '', options: SYNC_OPTIONS_LIST},
];


export const PRINTFUL_PRODUCTS_VARIANTS_PRICE_FIELDS_LIST: any = [
    /*{attribute: "product_id", label: "Product Id", cssClass: ''},
    {attribute: "variant_id", label: "Variant Id", cssClass: ''},*/
    {attribute: "product_type", label: "Product Type", cssClass: ''},
    /*{attribute: "category", label: "Category", cssClass: ''},*/
    {attribute: "product_title", label: "Product", cssClass: ''},
    {attribute: "name", label: "Variant", cssClass: ''},
    {attribute: "price", label: "Price (USD)", cssClass: ''},
    {attribute: "size", label: "Size", cssClass: ''},
    {attribute: "color", label: "Color", cssClass: ''},
];
